import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { useCallback } from 'react';
import { Button } from '../Button';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
export const Pagination = ({ className, total, size = 5, page, onChange, ...rest }) => {
    const t = useLocales();
    const loadPrevPage = useCallback(() => {
        if (!page || !onChange)
            return;
        const p = page > 1 ? page - 1 : 1;
        onChange(p);
    }, [page, onChange]);
    const pageCount = Math.ceil(total / size);
    const loadNextPage = useCallback(() => {
        if (!page || !onChange)
            return;
        onChange(page + 1);
    }, [page, onChange]);
    if (pageCount <= 1)
        return null;
    return (_jsxs("div", { className: classnames(className, styles.paginaton), ...rest, children: [page > 1 && (_jsx(Button, { className: styles.button, colorScheme: "light", round: false, onClick: loadPrevPage, children: t('Previous') })), Array.from({ length: pageCount }, (_, idx) => idx + 1).map((num) => (_jsx(Button, { colorScheme: page === num ? 'primary' : 'light', round: false, onClick: () => onChange?.(num), className: classnames(styles.page, page === num ? styles.selected : undefined), children: num }, num))), page < pageCount && (_jsx(Button, { className: styles.button, colorScheme: "light", round: false, onClick: loadNextPage, children: t('Next') }))] }));
};
